import React, { useEffect, useState } from 'react'
import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonTitle,
  IonSearchbar,
  IonList,
  IonSpinner,
  IonLabel,
  IonItem,
  IonToggle,
  IonChip,
  IonGrid,
  IonRow,
  IonLoading,
  IonCard,
  IonContent,
  IonToast,
  IonCardHeader,
  IonCardContent,
  useIonViewWillEnter,
} from '@ionic/react'
import { chevronBack, closeCircleOutline } from 'ionicons/icons'
import { BaseSyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getPatientMedicalHistorySelector } from '../selectors'
import { IOption, IPNNVOption } from '../../../common/common.types'
import useDeviceMetrics from '../../../utilities/useDeviceMetrics'
import { setSelectedOption } from '../../patientInformation/store/patientInformation.actions'
import { PatientInformationConstants } from '../../patientInformation/store/patientInformation.constants'
import { useHistory } from 'react-router-dom'
import { getAllPNNVOptionsSelector, getPatientMedicalHistoryOptionsSelector } from '../../options/selectors'
import {
  setEmergencyInfoForm,
  setObtainedFrom,
  setSelectedMedicalHistory,
  setSelectedMedicalHistoryIcdNemsisBasic,
  setSelectedMedicalHistoryPNNV,
} from '../store/patientMedicalHistory.actions'
import { IConfigurationsState } from '../../configurations/store/configurations.types'
import { getConfigurationsSelector } from '../../configurations/selectors'
import { PatientMedicalHistoryLayoutOptionsConstants } from '../store/patientMedicalHistoryLayoutOptions.constants'
import { Virtuoso } from 'react-virtuoso'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import CustomInput from '../../../components/custominput/CustomInput.component'
import { IPatientMedicalHistoryOption } from '../store/patientMedicalHistory.types'
import './MedicalHistoryLookup.component.css'
import { showAlert } from '../../../components/alert/store/alert.actions'
import { IAlertState } from '../../../components/alert/store/alert.types'
import { ToastColor } from '../../../components/toast/store/toast.constants'
import { getToastProps } from '../../../components/toast/toastIcon.util'
const MedicalHistoryLookupContent: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const [showToast, setShowToast] = useState(false)
  const [isWarning, setIsWarning] = useState(false)
  const [toastMessage, setToastMessage] = useState('')
  const patientMedicalHistory = useSelector(getPatientMedicalHistorySelector)
  const { medicalHistory, medicalHistoryIcdNemsisBasic, medicalHistoryPNNV } = patientMedicalHistory
  const patientMedicalHistoryOptions = useSelector(getPatientMedicalHistoryOptionsSelector)
  const { medicalHistoryOptionsFullList, medicalHistoryIcdNemsisBasicOptionsFullList } = patientMedicalHistoryOptions
  const { isTablet: isTabletDevice } = useDeviceMetrics()
  const configuration: IConfigurationsState = useSelector(getConfigurationsSelector)
  const { serviceConfig } = configuration

  const savedMedicalHistoryChip =
    serviceConfig.PR_PMHX_LAYOUT === PatientMedicalHistoryLayoutOptionsConstants.ICD_10_NEMSIS_BASIC
      ? [...medicalHistoryIcdNemsisBasic, ...medicalHistory]
      : medicalHistory
  const savedMedicalHistory = medicalHistory
  const savedMedicalHistoryIcdNemsisBasic = medicalHistoryIcdNemsisBasic
  const medicalHistoryFullOptionsList =
    serviceConfig.PR_PMHX_LAYOUT === PatientMedicalHistoryLayoutOptionsConstants.ICD_10_NEMSIS_BASIC
      ? medicalHistoryIcdNemsisBasicOptionsFullList
      : medicalHistoryOptionsFullList

  const allPNNVOptions = useSelector(getAllPNNVOptionsSelector)
  const pnnvOptions = allPNNVOptions?.['eHistory.08']

  const [searchValue, setSearchValue] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [searchResult, setSearchResult] = useState(medicalHistoryFullOptionsList.slice(0, 20))

  useIonViewWillEnter(() => {
    setSearchValue('')
  })

  const goBack = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    if (isTabletDevice) {
      dispatch(setSelectedOption(PatientInformationConstants.PATIENT_MEDICAL_HISTORY_OPTION))
      history.push(TabConstants.PATIENT_INFO_ROUTE)
    } else {
      history.push(TabConstants.PATIENT_MEDICAL_HISTORY)
    }
  }

  const handleSearch = (e: CustomEvent) => {
    setSearchValue(e.detail.value)
    setIsLoading(true)
    let result = []
    if (e.detail.value === '') {
      result = medicalHistoryFullOptionsList.slice(0, 20)
    } else {
      result = medicalHistoryFullOptionsList.filter((history) =>
        history.name?.toLowerCase().includes(e.detail.value.toLowerCase().trim())
      )
    }
    setSearchResult(result)
  }

  const handleToggle = (e: BaseSyntheticEvent, option: IPatientMedicalHistoryOption) => {
    e.preventDefault()
    if (serviceConfig.PR_PMHX_LAYOUT === PatientMedicalHistoryLayoutOptionsConstants.ICD_10_NEMSIS_BASIC) {
      if (e.target.checked) {
        savedMedicalHistoryIcdNemsisBasic.push(option)
        dispatch(setSelectedMedicalHistoryPNNV(null))
      } else {
        if (savedMedicalHistoryIcdNemsisBasic.filter((o) => o.id === option.id).length > 0) {
          savedMedicalHistoryIcdNemsisBasic.splice(
            savedMedicalHistoryIcdNemsisBasic.findIndex((o) => o.id === option.id),
            1
          )
        }
      }
      dispatch(setSelectedMedicalHistoryIcdNemsisBasic(savedMedicalHistoryIcdNemsisBasic))
    } else {
      if (e.target.checked) {
        savedMedicalHistory.push(option)
        dispatch(setSelectedMedicalHistoryPNNV(null))
      } else {
        if (savedMedicalHistory.filter((o) => o.id === option.id).length > 0) {
          savedMedicalHistory.splice(
            savedMedicalHistory.findIndex((o) => o.id === option.id),
            1
          )
        }
      }
      dispatch(setSelectedMedicalHistory(savedMedicalHistory))
    }
  }

  const removeFilterChip = (id: number | undefined, name: string | undefined) => {
    if (serviceConfig.PR_PMHX_LAYOUT === PatientMedicalHistoryLayoutOptionsConstants.ICD_10_NEMSIS_BASIC) {
      if (id === -99 || id === 0) {
        savedMedicalHistory.splice(
          savedMedicalHistory.findIndex((o) => o.name === name),
          1
        )
        dispatch(setSelectedMedicalHistory(savedMedicalHistory))
      } else {
        savedMedicalHistoryIcdNemsisBasic.splice(
          savedMedicalHistoryIcdNemsisBasic.findIndex((o) => o.id === id),
          1
        )
        dispatch(setSelectedMedicalHistoryIcdNemsisBasic(savedMedicalHistoryIcdNemsisBasic))
      }
    } else {
      if (id === -99 || id === 0) {
        savedMedicalHistory.splice(
          savedMedicalHistory.findIndex((o) => o.name === name),
          1
        )
      } else {
        savedMedicalHistory.splice(
          savedMedicalHistory.findIndex((o) => o.id === id),
          1
        )
      }
      dispatch(setSelectedMedicalHistory(savedMedicalHistory))
    }
  }

  const pushData = () => {
    const chunk = medicalHistoryFullOptionsList.slice(searchResult.length, searchResult.length + 20)
    setSearchResult([...searchResult, ...chunk])
  }

  useEffect(() => {
    setIsLoading(false)
  }, [searchResult])

  const loadData = () => {
    if (searchValue === '') {
      setTimeout(() => {
        if (searchResult.length < medicalHistoryFullOptionsList.length) {
          pushData()
        }
      }, 200)
    }
  }

  useEffect(() => {
    if (searchValue) {
      let content: HTMLIonContentElement | null = document.querySelector(':not(.ion-page-hidden) > ion-content')
      content?.scrollToTop(200)
      content = null
    }
  }, [searchValue])

  const cancel = () => {
    setSearchValue('')
  }

  const save = () => {
    const historyCheck = savedMedicalHistory.filter(
      (history) => history.name?.toLowerCase() === searchValue.toLowerCase()
    )

    if (historyCheck.length === 0) {
      let id = 0
      if (serviceConfig.PR_PMHX_LAYOUT === PatientMedicalHistoryLayoutOptionsConstants.ICD_10_NEMSIS_BASIC) {
        id = -99
      }
      savedMedicalHistory.push({
        id: id,
        name: searchValue,
      })
      dispatch(setSelectedMedicalHistory(savedMedicalHistory))
      setToastMessage('Medical history successfully added')
      setSearchValue('')
      setIsWarning(false)
      setShowToast(true)
      dispatch(setSelectedMedicalHistoryPNNV(null))
    } else {
      setToastMessage('This Medical history was already entered')
      setIsWarning(true)
      setShowToast(true)
    }
  }
  const togglePNNVHandler = (isChecked: boolean, option: IOption) => {
    if (
      ((medicalHistory && medicalHistory.length > 0) ||
        (medicalHistoryIcdNemsisBasic && medicalHistoryIcdNemsisBasic.length > 0)) &&
      isChecked
    ) {
      dispatch(setSelectedMedicalHistoryPNNV(null))
      showConfirmationBeforeClearingRegularValues(isChecked, option)
    } else {
      togglePNNVOption(isChecked, option)
    }
  }
  const showConfirmationBeforeClearingRegularValues = (isChecked: boolean, option: IOption) => {
    const alertState: IAlertState = {
      header: t('patientMedicalHistory.PatientMedicalHistory'),
      message: t('pnnv.userConfirmationMessage'),
      buttons: [
        { text: t('pnnv.cancel') },
        { text: t('pnnv.continueAndClear'), role: 'destructive', handler: () => togglePNNVOption(true, option) },
      ],
      showEqualWidthButton: true,
    }
    dispatch(showAlert(alertState))
  }

  const togglePNNVOption = (isChecked: boolean, option: IOption) => {
    if (medicalHistory && medicalHistory.length > 0) {
      dispatch(setSelectedMedicalHistory([]))
    }
    if (medicalHistoryIcdNemsisBasic && medicalHistoryIcdNemsisBasic.length > 0) {
      dispatch(setSelectedMedicalHistoryIcdNemsisBasic([]))
    }

    if (isChecked) {
      if (option.name) {
        const obj = {
          id: option.id,
          name: option.name,
          pn: '',
          nv: '',
        }
        if (option.nemsisCode) {
          if (option.isPN) {
            obj.pn = String(option.nemsisCode)
          } else if (option.isNV) {
            obj.nv = String(option.nemsisCode)
          }
        }
        dispatch(setSelectedMedicalHistoryPNNV(obj as IPNNVOption))
        dispatch(setEmergencyInfoForm(null))
        dispatch(setObtainedFrom([]))
      }
    } else {
      dispatch(setSelectedMedicalHistoryPNNV(null))
    }
  }

  useEffect(() => {
    if (showToast) {
      setTimeout(() => {
        setShowToast(false)
      }, 2000)
    }
  }, [showToast])

  useEffect(() => {
    setTimeout(() => {
      let content: HTMLIonContentElement | null = document.querySelector('#medical-history-list-row')
      content?.scrollTo(content?.scrollWidth, 0)
      content = null
    }, 10)
  }, [savedMedicalHistoryChip])

  return (
    <>
      {showToast && (
        <IonToast
          position='top'
          isOpen={showToast}
          message={toastMessage}
          duration={2000}
          {...getToastProps(isWarning ? ToastColor.Warning : ToastColor.Success)}
          onDidDismiss={() => setShowToast(false)}
        />
      )}
      <IonHeader>
        <IonToolbar color='light'>
          <IonButtons slot='start'>
            <IonButton data-testid='Back' color='primary-alt' onClick={goBack}>
              <IonIcon icon={chevronBack} />
              {t('common.buttons.Back')}
            </IonButton>
          </IonButtons>
          <IonTitle data-testid='HeaderTitle'>{t('patientMedicalHistory.Title')}</IonTitle>
        </IonToolbar>
        <IonToolbar className='toolbar-padding'>
          <IonLabel className='toolbar-label' slot='start'>
            {t('patientMedicalHistory.PatientHistory')}:
          </IonLabel>
        </IonToolbar>
        {savedMedicalHistoryChip.length > 0 ? (
          <IonToolbar>
            <IonGrid class='ion-no-padding'>
              <IonRow class='ion-nowrap no-flex-shrink' id='medical-history-list-row'>
                {savedMedicalHistoryChip.map((option: IOption) => (
                  <IonChip
                    data-testid={`Chip${option.id}`}
                    key={`Chip_${option.id}${option.name}`}
                    className='lookup-search-chips'>
                    <IonLabel>{option.name}</IonLabel>
                    <IonIcon
                      color='white'
                      icon={closeCircleOutline}
                      onClick={() => removeFilterChip(option.id, option.name)}
                    />
                  </IonChip>
                ))}
              </IonRow>
            </IonGrid>
          </IonToolbar>
        ) : (
          <IonRow>
            {medicalHistory ? null : (
              <IonToolbar color='light' className='labelHeader'>
                <IonLabel color='medium'>{t('patientMedicalHistory.HistoryLabel')}</IonLabel>
              </IonToolbar>
            )}
          </IonRow>
        )}
        {medicalHistoryPNNV && (
          <IonToolbar>
            <IonGrid class='ion-no-padding'>
              <IonRow class='ion-nowrap no-flex-shrink' id='pnnv-options-list-row'>
                <IonChip
                  data-testid={`PNNVChip${medicalHistoryPNNV.id}`}
                  key={`PNNVChip_${medicalHistoryPNNV.id}${medicalHistoryPNNV.name}`}
                  className='lookup-search-chips'>
                  <IonLabel>{medicalHistoryPNNV.name}</IonLabel>
                  <IonIcon
                    color='white'
                    icon={closeCircleOutline}
                    onClick={() => dispatch(setSelectedMedicalHistoryPNNV(null))}
                  />
                </IonChip>
              </IonRow>
            </IonGrid>
          </IonToolbar>
        )}
        <IonToolbar color='light' className='ion-padding-top'>
          <IonSearchbar
            data-testid='Searchbar'
            debounce={100}
            value={searchValue}
            onIonChange={handleSearch}
            autocomplete='off'></IonSearchbar>
        </IonToolbar>
      </IonHeader>
      <IonContent color='light' fullscreen>
        <IonCard className={isTabletDevice ? 'medical-history-toggle-list card-width' : 'card-margin'}>
          <IonList>
            {isLoading && <IonSpinner data-testid='Spinner' />}
            {!searchResult.length && (
              <>
                <IonCard className='ion-no-margin'>
                  <IonCardHeader>
                    <IonItem key={'no_options_found'}>
                      <IonLabel>
                        {t('common.NoSearchResults')}
                        {`"${searchValue}"`}
                      </IonLabel>
                    </IonItem>
                  </IonCardHeader>
                  <IonCardContent>
                    <CustomInput heading='Manually add as new history' cancel={cancel} save={save} />
                  </IonCardContent>
                </IonCard>
              </>
            )}
            {medicalHistoryFullOptionsList && (
              <>
                <Virtuoso
                  style={{
                    height: isTabletDevice ? 'calc(100vh - 520px)' : 'calc(100vh - 450px)',
                    paddingBottom: pnnvOptions?.length ? `${pnnvOptions.length * 60 + 20}px` : '0px',
                  }}
                  data={searchResult}
                  endReached={loadData}
                  overscan={10}
                  increaseViewportBy={{ top: 2000, bottom: 2000 }}
                  itemContent={(index, option: any) => {
                    return (
                      <div style={{ minHeight: '44px' }} className='webkit-line-clamp-2'>
                        <IonItem key={`Option_${option.id}`} data-skip-auto-enhance>
                          <IonLabel>{option.name}</IonLabel>
                          <IonToggle
                            slot='start'
                            name={option.name}
                            value={`${option.id}`}
                            checked={
                              serviceConfig.PR_PMHX_LAYOUT ===
                              PatientMedicalHistoryLayoutOptionsConstants.ICD_10_NEMSIS_BASIC
                                ? savedMedicalHistoryIcdNemsisBasic.filter((o) => o.id === option.id).length > 0
                                : savedMedicalHistory.filter((o) => o.id === option.id).length > 0
                            }
                            onClick={(e) => handleToggle(e, option)}
                            color={'zoll-blue-secondary'}
                          />
                        </IonItem>
                      </div>
                    )
                  }}
                />
                {pnnvOptions && pnnvOptions.length > 0 && (
                  <div className='medical-history-pnnv-selection-section'>
                    <hr className='picklist-divider' />
                    <IonList lines='full'>
                      {pnnvOptions?.map((option: IOption) => (
                        <IonItem
                          key={'PNNVOption_' + option.id}
                          data-testid={`PNNVOption_${option.id}`}
                          className={`${
                            medicalHistoryPNNV?.id === option.id ? 'selected-pnnv-option' : ''
                          } pnnv-option`}
                          data-skip-auto-enhance>
                          <IonLabel id={`PNNVoptionLabel_${option.id}`}>{option.name}</IonLabel>
                          <IonToggle
                            slot='start'
                            name={option.name}
                            value={`${option.id}`}
                            checked={medicalHistoryPNNV?.id === option.id}
                            onClick={(e: BaseSyntheticEvent) => togglePNNVHandler(e.target.checked, option)}
                            disabled={!!medicalHistoryPNNV && medicalHistoryPNNV?.id !== option.id}
                          />
                        </IonItem>
                      ))}
                    </IonList>
                  </div>
                )}
              </>
            )}
          </IonList>
          {isLoading && <IonLoading data-testid='Loader' isOpen animated showBackdrop spinner={'crescent'} />}
        </IonCard>
      </IonContent>
    </>
  )
}

export default MedicalHistoryLookupContent
